var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canCallPatient)?_c('div',{staticClass:"user-online-status"},[_c('b-form-checkbox',{staticClass:"user-online-status__switcher",attrs:{"checked":_vm.online,"inline":"","switch":""},on:{"change":_vm.onChange}}),_c('div',{staticClass:"user-online-status__circle",class:{
      'offline': !_vm.online
    },attrs:{"title":_vm.statusText}},[_c('div',{staticClass:"user-online-status__circle-inner",class:{
        'offline': !_vm.online
      }})]),_c('span',{staticClass:"user-online-status__text"},[_vm._v(_vm._s(_vm.statusText))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }